import { render, staticRenderFns } from "./ClientFiles.vue?vue&type=template&id=0b4ec471&scoped=true&"
import script from "./ClientFiles.vue?vue&type=script&lang=js&"
export * from "./ClientFiles.vue?vue&type=script&lang=js&"
import style0 from "./ClientFiles.vue?vue&type=style&index=0&id=0b4ec471&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4ec471",
  null
  
)

export default component.exports